export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/8afc9950a5e22530ededf05659439b63.png";